import React from 'react';

import { UiButton } from '@nfctron/nexus-react';

import { Loader, Text } from '@mantine/core';
import { type ContextModalProps } from '@mantine/modals';

import { APP_I18N_NAMESPACE } from '@root/lib/constants/common';
import { useTranslate } from '@root/lib/hooks/useTranslation';
import { type ModalComponent } from '@root/lib/types/components';

/**
 * OrderCreateSuccessModal modal
 * @author filipditrich <ditrich@nfctron.com>
 * @constructor
 */
export const OrderCreateSuccessModal: ModalComponent<ContextModalProps<OrderCreateSuccessModalProps>> = ({
	id,
	context,
	innerProps: { onButtonClick },
}) => {
	const { t } = useTranslate(APP_I18N_NAMESPACE.COMMON, OrderCreateSuccessModal.displayName);

	return (
		<React.Fragment>
			<div className="flex flex-col gap-4 text-center">
				{/* heading */}
				<Text size="md" c="lucky-point" fw={700}>
					{t('heading')}
				</Text>
				{/* loader */}
				<div className="mx-auto py-12">
					<Loader variant="dots" size="xl" color="lucky-point" />
				</div>
				{/* text */}
				<Text size="md">{t('text')}</Text>
				{/* close button */}
				<UiButton variant="primary" onClick={async () => onButtonClick({ ...context, id })}>
					{t('button.text')}
				</UiButton>
			</div>
		</React.Fragment>
	);
};

/**
 * OrderCreateSuccessModal modal props type
 * @export
 */
export type OrderCreateSuccessModalProps = {
	onButtonClick: (context: ContextModalProps['context'] & { id: string }) => void;
};

/**
 * OrderCreateSuccessModal modal display name
 * @type {ComponentDisplayName}
 */
OrderCreateSuccessModal.displayName = 'modal/OrderCreateSuccessModal';
